module.exports = __webpack_public_path__ + "img/11-November.f27cac5c.jpg";